<template>

  <rpm-table
    title="Perfis de acesso"
    :columns="columns"
    :data="rolesList"
    :loading="tableDataIsLoading"
  >
    <template #actions="{ item }">
      <rpm-button
        color="transparent"
        icon="fa-solid fa-chevron-right"
        tooltip-text="Editar"
        :to="{ name: 'EditPermissions', params: {id: item.id} }"
      ></rpm-button>
    </template>
  </rpm-table>

</template>


<script>

import roleRepository from "#repositories/roleRepository";
import RpmTable from "#components/RpmTable.vue";
import Badge from "#components/Badge.vue";

export default {
    name: "AccessProfile",
    components: {
      RpmTable,
      Badge
    },
    data() {
      return {
        columns: [
          {
            field: 'name',
            label: 'Perfil',
          },
        ],
        pagination: {
          page: this.$route.query.page ?? 1,
          per_page: 10,
          last_page: 0,
          links: []
        },
        rolesList: [],
        tableDataIsLoading: false
      }
    },
    methods: {
      async getRoles(){
        this.tableDataIsLoading = true;

        this.rolesList = (await roleRepository.getRoles()).data ?? [];

        this.tableDataIsLoading = false;
      }
    },
    mounted() {
      this.getRoles();
    }
}
</script>
